// Implements: F-UIX-008, F-UIX-015, F-UIX-010
/**
 * The closed attempt bucket, presented as a wait.
 *
 * `role="status"` and not `role="alert"`, and no `Toast` of failure anywhere
 * near it: a `429` is the system saying "in a moment", not "you got it wrong"
 * (DD8). The countdown is on screen because a disabled button with no reason
 * is indistinguishable from a broken one.
 *
 * The number arrives already counted down; owning the clock is the hook's job
 * and this component has no state at all.
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import styles from "./RateLimitNotice.module.css";

export interface RateLimitNoticeProps {
  /** Seconds still to wait, as the state machine counts them. */
  readonly seconds: number;
}

export function RateLimitNotice({ seconds }: RateLimitNoticeProps): ReactElement {
  const { t } = useTranslation();

  return (
    <div className={styles.notice} role="status">
      <p className={styles.title}>{t("auth.rateLimit.title")}</p>
      <p className={styles.body}>{t("auth.rateLimit.body")}</p>
      <p className={styles.countdown}>{t("auth.rateLimit.countdown", { seconds })}</p>
    </div>
  );
}
